const Loader = ({ width, loaderMessage, height, borderRadius }) => {
  return (
    <div
      className="page-loader d-flex align-center jc-center"
      style={{
        flexDirection: "column",
        width: width ? width : "78%",
        textAlign: "center",
        opacity: "1",
        backgroundColor: "#fff",
        height: height ? height : "66%",
        position: "absolute",
        zIndex: "989",
        borderRadius: borderRadius ? "0 0 25px 25px" : "0",
      }}
    >
      <viedoc-spinner class=""></viedoc-spinner>
      <label>{loaderMessage ? loaderMessage : null}</label>
    </div>
  );
};

export default Loader;
